import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
	selector: 'app-server-error',
	standalone: true,
	imports: [MatButtonModule],
	templateUrl: './server-error.component.html',
	styleUrl: './server-error.component.scss'
})
export class ServerErrorComponent {

	private snack = inject(MatSnackBarRef<any>)

	close() {
		this.snack.dismiss()
	}

}
